import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page">
      <Nav />
      <div className="page-hero">
        <div className="page-hero-bg" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1483721310020-03333e577078?w=1600&q=80')" }} />
        <div className="page-hero-content">
          <p className="eyebrow eyebrow-light">Our Story</p>
          <h1>Built from a belief<br/>that softness is power.</h1>
          <p>The story of Saviar is the story of one woman's refusal to choose between luxury and healing — and the brand that emerged when she stopped.</p>
        </div>
      </div>

      <section className="section">
        <div className="container-x">
          <div className="grid-2" style={{ gap: 80 }}>
            <Reveal>
              <div className="feature-image-wrap" style={{ aspectRatio: "4/5" }}>
                <img src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=900&q=80" alt="Saviar founder" />
              </div>
            </Reveal>
            <Reveal delay={120}>
              <p className="eyebrow">The Founder</p>
              <div className="divider" />
              <h2 className="display" style={{ fontSize: "clamp(1.8rem, 3vw, 2.6rem)", color: "var(--charcoal)", marginBottom: 24 }}>A curator. A guide. A visionary.</h2>
              <p className="body-lg" style={{ marginBottom: 24 }}>
                Saviar was born from a personal journey through burnout, identity loss, and the deep desire to rebuild a life that felt luxurious from the inside out. Years of studying biochemistry, wellness, and the psychology of feminine identity led to the intersection that became this brand.
              </p>
              <p className="body-sm" style={{ marginBottom: 40 }}>
                Saviar is a sanctuary for women ready to stop shrinking and start designing their softest, most intentional lives.
              </p>
              <blockquote style={{ fontFamily: "var(--serif)", fontStyle: "italic", fontSize: "1.15rem", color: "var(--warm-gray)", borderLeft: "2px solid var(--gold)", paddingLeft: 20 }}>
                "The woman you are becoming already knows what she deserves. Saviar is just the space that confirms it."
              </blockquote>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="section dark-section">
        <div className="container-x">
          <div style={{ textAlign: "center", maxWidth: 820, margin: "0 auto 48px" }}>
            <p className="eyebrow" style={{ marginBottom: 16 }}>Brand Mission</p>
            <h2 className="display" style={{ fontSize: "clamp(1.8rem, 3vw, 2.8rem)", color: "var(--ivory)" }}>
              To make refinement accessible, and softness a standard — not a reward.
            </h2>
          </div>
          <div className="grid-2">
            {[
              ["What We Believe", "Luxury is a mindset before it is a circumstance. Your nervous system deserves regulation as much as your wardrobe deserves curation. Women who choose softness are not opting out — they are opting up."],
              ["How We Work", "Every Saviar experience blends evidence-based wellness science with the aesthetic intelligence of luxury lifestyle curation. Nothing is arbitrary. Everything is intentional."],
            ].map(([h, p]) => (
              <Reveal key={h}>
                <div style={{ padding: 48, border: "1px solid rgba(184,150,90,.12)" }}>
                  <p className="eyebrow" style={{ marginBottom: 16 }}>{h}</p>
                  <p className="body-sm" style={{ lineHeight: 1.9 }}>{p}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <div className="cta-band">
        <p className="eyebrow" style={{ marginBottom: 24 }}>Begin Here</p>
        <h2>You've read the story.<br/>Now write yours.</h2>
        <div className="btn-group">
          <Link to="/apply" className="btn btn-primary">Apply Now</Link>
          <Link to="/experiences" className="btn btn-outline">Explore Experiences</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
